import Joi from '@hapi/joi'

export const collectionSchemaObject = {
    collectionCategoryCode: Joi.string().required().invalid("00").min(3).max(3).label("Collection Category Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Collection Category Code required`,
        "string.pattern.base": `Collection Category Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as collection category code`
    }),
    collectionCategoryName: Joi.string().required().label("Collection Category Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Collection Category Name required`,
        "string.pattern.base": `Please enter valid Category Name `,
    }),

    productID: Joi.number().invalid(0).required().label("Product").messages({
        "any.required": `Product ID required`
    }),
    isActive: Joi.boolean().label("Active"),
    
}